/**
 * DeleteModal Component
 * 
 * A reusable confirmation modal used to confirm deletion actions across modules.
 * 
 * Props:
 * - open (boolean): Controls the visibility of the modal.
 * - dialogClose (function): Callback to close the modal.
 * - deleteHandler (function): Function to execute on confirmation of deletion.
 * - id (string | number): The ID of the item to be deleted.
 * - moduleName (string): The name of the module/item shown in the modal heading.
 * - deleteType (string): Type/category of the delete action (optional).
 * - description (string): Custom message to display in the confirmation text.
 * 
 * Features:
 * - Styled modal with Yes/No action buttons.
 * - `Yes` triggers `deleteHandler` with `id` and `deleteType`.
 * - `No` closes the modal.
 */
import React from 'react'
import Modal from '../modal/modal'
import './../modal/modal.scss'

export default function DeleteModal(props) {
  let { deleteHandler, id, open, dialogClose, moduleName, deleteType, description = 'Please confirm your action', contentClassName = '', fullWidth = true, maxWidth = 'sm', disableDelete = false } = props
  return (
    <Modal
      open={open}
      onClose={dialogClose}
      fullWidth={fullWidth}
      maxWidth={maxWidth}
      modalHeading={`Delete ${moduleName}`}
      modalSaveTxt={disableDelete ? null : <span data-cy="confirm-delete">Yes</span>}
      modalCloseTxt={disableDelete ? 'Close' : 'No'}
      onClick={() => deleteHandler(id, deleteType)}
      showActionBtn
      savebtnClass='createBtn'
      cxlbtnClass='cancelBtn'
      primary
      dataCy={props?.dataCy || 'delete-dialog'}
    >
      {props.children || (
        <div className={contentClassName}>
          <p>Are you sure you want to delete {description}? </p>
          <p className="text-danger fw-bold mb-0">This action cannot be undone.</p>
        </div>
      )}
    </Modal>
  )
}
